import { employeeUpdateRequest } from '@gtpl/shared-models/gtpl';
import { Injectable } from '@nestjs/common';
import { Entity } from 'typeorm';
import { EmployeeDetailsDTO } from '../dto/employee-details.dto';
import { EmployeeDetails } from '../employee-details.entity';
import { EmployeeEducationDetails } from '../employee-education-details.entity';
import { EmployeeExperienceDetails } from '../employee-experience-details.entity';
import { EmployeeFamilyDetails } from '../employee-family-details.entity';
import { EmployeeIdProofDetails } from '../employee-id-proof-details.entity';
import { EmployeeTerminationDTO } from './employee-termination.dto';

@Injectable()
export class EmployeesAdapter {
  /**
   *
   * @param employeesDto
   * @returns Employees entity
   */
  public convertDtoToEntity(employeesDto: EmployeeDetailsDTO, isUpdate: boolean = false): EmployeeDetails {
    const employees = new EmployeeDetails();
    if (isUpdate) {
      employees.employeeId = employeesDto.employeeId;
    }
    employees.employeeName = employeesDto.employeeName;
    employees.employeeLastName = employeesDto.employeeLastName;
    employees.employeeCode = employeesDto.employeeCode;
    employees.mobileNumber = employeesDto.mobileNumber;
    employees.employeeRole = employeesDto.employeeRole;
    employees.unitId = employeesDto.unitId;
    employees.prefix = employeesDto.prefix;
    employees.dateOfBirth = employeesDto.dateOfBirth;
    employees.gender = employeesDto.gender;
    employees.maritualStatus = employeesDto.maritualStatus;
    employees.altMobileNumber = employeesDto.altMobileNumber;
    employees.emailID = employeesDto.emailID;
    employees.bloodGroup = employeesDto.bloodGroup;
    employees.nationality = employeesDto.nationality;
    employees.departmentId = employeesDto.departmentId;
    // employees.deptId=employeesDto.deptId;
    employees.priorityOne = employeesDto.priorityOne;
    employees.priorityType = employeesDto.priorityType;
    employees.currentAddress = employeesDto.currentAddress;
    employees.permanentAddress = employeesDto.permanentAddress;
    employees.qualification = employeesDto.qualification;
    employees.yearsOfExperience = employeesDto.yearsOfExperience;
    employees.companyEmail = employeesDto.companyEmail;
    employees.employeeMode = employeesDto.employeeMode;
    employees.employeeStatus = employeesDto.employeeStatus;
    employees.contractorName = employeesDto.contractorName;
    employees.shiftGroup = employeesDto.shiftGroup;
    employees.dateOfJoin = employeesDto.dateOfJoin;
    employees.dateOfleave = employeesDto.dateOfleave;
    employees.workstationNumber = employeesDto.workstationNumber;
    employees.healthCardNumber = employeesDto.healthCardNumber;
    employees.uanNumber = employeesDto.uanNumber;
    employees.salary = employeesDto.salary;
    employees.bankAccountNumber = employeesDto.bankAccountNumber;
    employees.ifscCode = employeesDto.ifscCode;
    employees.designation = employeesDto.designation;
    employees.dateOfEntry = employeesDto.dateOfEntry;
    employees.emergencyContactNo = employeesDto.emergencyContactNo;
    employees.emergencyContactName = employeesDto.emergencyContactName;
    employees.isProbPeriodCompleted = employeesDto.isProbPeriodCompleted;
    employees.transportation = employeesDto.transportation;
    employees.accommodation = employeesDto.accommodation;
    employees.isAuditCompleted = employeesDto.isAuditCompleted;
    employees.employeeType = employeesDto.employeeType;
    employees.pickUpPoint = employeesDto.pickUpPoint;
    employees.routeNumber = employeesDto.routeNumber;
    employees.image = employeesDto.image;
    employees.employeeCategory = employeesDto.employeeCategory;
    employees.wageType = employeesDto.wageType;
    employees.aadhaarNumber = employeesDto.aadhaarNumber;
    employees.reportingManager = employeesDto.reportingManager;


    // employees.emailId=employeesDto.emailId;
    employees.createdUser = employeesDto.createdUser;
    employees.updatedUser = employeesDto.updatedUser;
    employees.isActive = employeesDto.isActive == undefined ? true : employeesDto.isActive;

    const familyDetails: EmployeeFamilyDetails[] = [];
    for (const sampleDto of employeesDto.familyDetails) {
      const familyDetailsObj = new EmployeeFamilyDetails();
      familyDetailsObj.employeeFamilyId = sampleDto.employeeFamilyId;
      familyDetailsObj.relation = sampleDto.relation;
      familyDetailsObj.famAadhaarNo = sampleDto.famAadhaarNo;
      familyDetailsObj.contactNo = sampleDto.contactNo;
      familyDetailsObj.famDateOfBirth = sampleDto.famDateOfBirth;
      familyDetailsObj.familyMemName = sampleDto.familyMemName;
      familyDetailsObj.isActive = sampleDto.isActive;
      familyDetails.push(familyDetailsObj)
    }
    employees.familyDetails = familyDetails
    if (isUpdate) {
      employees.updatedUser = employees.updatedUser;
    } else {
      employees.isActive = true;
      // employees.isTerminated = No;
    }

    const educationDetails: EmployeeEducationDetails[] = [];
    for (const sampleDto of employeesDto.educationDetails) {
      const educationDetailsObj = new EmployeeEducationDetails();
      educationDetailsObj.employeeEducationId = sampleDto.employeeEducationId;
      educationDetailsObj.empQualification = sampleDto.empQualification;
      educationDetailsObj.specialization = sampleDto.specialization;
      educationDetailsObj.dateOfPassOut = sampleDto.dateOfPassOut;
      educationDetailsObj.percentage = sampleDto.percentage;
      educationDetailsObj.isActive = sampleDto.isActive;
      educationDetails.push(educationDetailsObj)
    }
    employees.educationDetails = educationDetails
    if (isUpdate) {
      employees.updatedUser = employees.updatedUser;
    } else {
      employees.isActive = true;
      // employees.isTerminated = No;
    }


    const idProofDetails: EmployeeIdProofDetails[] = [];
    for (const sampleDto of employeesDto.idProofDetails) {
      const idProofDetailsObj = new EmployeeIdProofDetails();
      idProofDetailsObj.employeeIdProofId = sampleDto.employeeIdProofId;
      idProofDetailsObj.idNumber = sampleDto.idNumber;
      idProofDetailsObj.idType = sampleDto.idType;
      idProofDetailsObj.isActive = sampleDto.isActive;
      idProofDetails.push(idProofDetailsObj)
    }
    employees.idProofDetails = idProofDetails
    if (isUpdate) {
      employees.updatedUser = employees.updatedUser;
    } else {
      employees.isActive = true;
      // employees.isTerminated = No;
    }

    const experienceDetails: EmployeeExperienceDetails[] = [];
    for (const sampleDto of employeesDto.experienceDetails) {
      const educationDetailsObj = new EmployeeExperienceDetails();
      educationDetailsObj.employeeExperienceId = sampleDto.employeeExperienceId;
      educationDetailsObj.organisation = sampleDto.organisation;
      educationDetailsObj.designation = sampleDto.designation;
      educationDetailsObj.designation = sampleDto.designation;
      educationDetailsObj.fromDate = sampleDto.fromDate;
      educationDetailsObj.toDate = sampleDto.toDate;
      educationDetailsObj.experience = sampleDto.experience;
      educationDetailsObj.isActive = sampleDto.isActive;
      experienceDetails.push(educationDetailsObj)
    }
    employees.experienceDetails = experienceDetails
    if (isUpdate) {
      employees.updatedUser = employees.updatedUser;
    } else {
      employees.isActive = true;
      // employees.isTerminated = No;
    }

    return employees;
  }

  public convertEntityToDto(employeeObject: EmployeeDetails): EmployeeDetailsDTO {
    const employeeDetailsDTO = new EmployeeDetailsDTO;
    employeeDetailsDTO.employeeId = employeeObject.employeeId;
    employeeDetailsDTO.employeeName = employeeObject.employeeName;
    employeeDetailsDTO.employeeLastName = employeeObject.employeeLastName;
    employeeDetailsDTO.employeeCode = employeeObject.employeeCode;
    employeeDetailsDTO.mobileNumber = employeeObject.mobileNumber;
    employeeDetailsDTO.unitId = employeeObject.unitId;
    // employeeDetailsDTO.emailId = employeeObject.emailId;
    employeeDetailsDTO.employeeRole = employeeObject.employeeRole;
    employeeDetailsDTO.isActive = employeeObject.isActive;
    employeeDetailsDTO.createdAt = employeeObject.createdAt;
    employeeDetailsDTO.updatedAt = employeeObject.updatedAt;
    employeeDetailsDTO.createdUser = employeeObject.createdUser;
    employeeDetailsDTO.updatedUser = employeeObject.updatedUser;
    employeeDetailsDTO.versionFlag = employeeObject.versionFlag;
    employeeDetailsDTO.employeeType = employeeObject.employeeType;
    employeeDetailsDTO.pickUpPoint = employeeObject.pickUpPoint;
    employeeDetailsDTO.routeNumber = employeeObject.routeNumber;
    employeeDetailsDTO.image = employeeObject.image;
    employeeDetailsDTO.employeeCategory = employeeObject.employeeCategory;
    employeeDetailsDTO.wageType = employeeObject.wageType;
    employeeDetailsDTO.aadhaarNumber = employeeObject.aadhaarNumber;
    employeeDetailsDTO.reportingManager = employeeObject.reportingManager;

    return employeeDetailsDTO;
  }

  // public convertTerminatedDtoToEntity(employeeTerminationDTO: EmployeeTerminationDTO,  isUpdate: boolean = true){
  //   const employees = new EmployeeDetails();
  //   if(isUpdate){
  //     employees.Id=employeeTerminationDTO.Id;
  //   }
  //   employees.isTerminated=employeeTerminationDTO.isTerminated;
  //   if (isUpdate) {
  //     employees.updatedUser = employees.updatedUser;
  //   } else {
  //     employees.status = true;
  //     // employees.isTerminated = Termination;
  //   }
  //  return employees;
  // }
}
